__turbopack_context__.v({
  "accordionHeading": "AccordionTableOfContents-module-scss-module__F5Yx-a__accordionHeading",
  "active": "AccordionTableOfContents-module-scss-module__F5Yx-a__active",
  "content": "AccordionTableOfContents-module-scss-module__F5Yx-a__content",
  "heading": "AccordionTableOfContents-module-scss-module__F5Yx-a__heading",
  "icon": "AccordionTableOfContents-module-scss-module__F5Yx-a__icon",
  "link": "AccordionTableOfContents-module-scss-module__F5Yx-a__link",
  "nested": "AccordionTableOfContents-module-scss-module__F5Yx-a__nested",
  "open": "AccordionTableOfContents-module-scss-module__F5Yx-a__open",
  "slide-down": "AccordionTableOfContents-module-scss-module__F5Yx-a__slide-down",
  "slide-up": "AccordionTableOfContents-module-scss-module__F5Yx-a__slide-up",
  "trigger": "AccordionTableOfContents-module-scss-module__F5Yx-a__trigger",
});
